import React from 'react';
import Route from './routes';
import './App.css';
import Loader from './components/common/Loader';
import ScrollToTop from './components/specific/ScrollToTop';
import useVersionChecker from './useVersionChecker'; // Adjust the path as necessary


function App() {
  useVersionChecker(); // Hook is invoked here

  return (
    <>
      <ScrollToTop />
      <Loader />
      <Route />
    </>
  );
}

export default App;
